/* import __COLOCATED_TEMPLATE__ from './daily-calendar.hbs.js'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { sortBy } from 'ilios-common/utils/array-helpers';
import { modifier } from 'ember-modifier';
import { DateTime } from 'luxon';
let DailyCalendarComponent = (_class = class DailyCalendarComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _defineProperty(this, "scrollView", modifier((element, [earliestHour]) => {
      // all of the hour elements are registered in the template as hour-0, hour-1, etc
      let hourElement = element.getElementsByClassName(`hour-6`)[0];
      if (earliestHour < 24 && earliestHour > 2) {
        hourElement = element.getElementsByClassName(`hour-${earliestHour}`)[0];
      }
      const {
        offsetTop
      } = hourElement;
      element.scrollTo({
        top: offsetTop,
        behavior: 'instant'
      });
    }));
  }
  get earliestHour() {
    if (!this.args.events) {
      return null;
    }
    return this.sortedEvents.reduce((earliestHour, event) => {
      const {
        hour
      } = DateTime.fromISO(event.startDate);
      return hour < earliestHour ? hour : earliestHour;
    }, 24);
  }
  get sortedEvents() {
    if (!this.args.events) {
      return [];
    }
    return sortBy(this.args.events, ['startDate', 'endDate', 'name']);
  }
  get hours() {
    const today = DateTime.fromJSDate(this.args.date).startOf('day');
    return [...Array(24).keys()].map(i => {
      const time = today.set({
        hour: i
      });
      return {
        hour: time.hour,
        longName: this.intl.formatDate(time, {
          hour: 'numeric',
          minute: 'numeric'
        }),
        shortName: this.intl.formatDate(time, {
          hour: 'numeric'
        })
      };
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { DailyCalendarComponent as default };